import type { SaveData } from '../types';
import { SAVE_KEY, SAVE_VERSION } from '../config';
import { STARTER_OUTFIT_IDS, STARTER_EQUIPPED, STARTER_PET_ID } from '../data/starter';

export const SaveSystem = {
  load(): SaveData | null {
    try {
      const raw = localStorage.getItem(SAVE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw) as SaveData;
      const migrated = SaveSystem.migrate(data);
      return migrated;
    } catch {
      return null;
    }
  },

  save(data: SaveData): void {
    try {
      localStorage.setItem(SAVE_KEY, JSON.stringify(data));
    } catch (e) {
      console.error('Save failed:', e);
    }
  },

  reset(): void {
    localStorage.removeItem(SAVE_KEY);
  },

  createNewSave(playerName: string): SaveData {
    const now = Date.now();
    return {
      version: SAVE_VERSION,
      profile: {
        name: playerName,
        appearance: { skinTone: 'light', hairColor: 'black', eyeColor: 'brown' },
        level: 1,
        createdAt: now,
      },
      currency: { stars: 99999, coins: 99999, gems: 99999 },
      ownedOutfits: STARTER_OUTFIT_IDS.map(id => ({ outfitId: id, acquiredAt: now })),
      currentEquipped: { ...STARTER_EQUIPPED },
      savedOutfits: [],
      ownedPets: [{
        petId: STARTER_PET_ID,
        nickname: '뽀삐',
        level: 1, exp: 0,
        happiness: 80, hunger: 70, cleanliness: 90,
        lastCaredAt: now, acquiredAt: now,
      }],
      activePetId: STARTER_PET_ID,
      hatchingEggs: [],
      questProgress: [],
      mathProgress: [],
      currentSeasonId: null,
      seasonProgress: 0,
      stats: { minigameBest: {}, rivalWins: 0, daysPlayed: 1, lastLoginAt: now, minigamesPlayCount: 0, outfitEquipCount: 0 },
      settings: { bgmVolume: 0.7, sfxVolume: 0.8, muted: false },
    };
  },

  migrate(data: SaveData): SaveData | null {
    if (data.version === SAVE_VERSION) return data;
    console.warn(`Save version ${data.version} unknown, discarding (will start fresh)`);
    return null;
  },
};
